export const Logo = ({ className = "h-9 w-auto" }) => (
  <a
    href="#top"
    data-testid="logo-link"
    className="flex items-center"
    aria-label="Triple O Creative Industries — home"
  >
    <img
      src="/images/logo.png"
      alt="Triple O Creative Industries"
      className={className}
      draggable="false"
    />
  </a>
);
